import { render, staticRenderFns } from "./SlideTypeIcon.vue?vue&type=template&id=4d7c8047&scoped=true&"
import script from "./SlideTypeIcon.vue?vue&type=script&lang=js&"
export * from "./SlideTypeIcon.vue?vue&type=script&lang=js&"
import style0 from "./SlideTypeIcon.vue?vue&type=style&index=0&id=4d7c8047&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7c8047",
  null
  
)

export default component.exports